import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

export function ViewToggle({ currentView, onViewChange }) {
  const views = [
    {
      id: 'grid',
      label: 'Grid View',
      icon: 'Grid3X3'
    },
    {
      id: 'list',
      label: 'List View', 
      icon: 'List'
    }
  ];

  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      {views?.map((view) => (
        <Button
          key={view?.id}
          variant={currentView === view?.id ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onViewChange?.(view?.id)}
          className={`
            flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-200
            ${currentView === view?.id 
              ? 'bg-white text-blue-600 shadow-sm border border-gray-200' 
              : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }
          `}
          title={view?.label}
        >
          <Icon 
            name={view?.icon} 
            size={16} 
            className={currentView === view?.id ? 'text-blue-600' : 'text-gray-400'}
          />
          <span className="text-sm font-medium hidden sm:inline">
            {view?.label}
          </span>
        </Button>
      ))}
    </div>
  );
}

export default ViewToggle;